import { render, staticRenderFns } from "./reportBreadcrumbs.vue?vue&type=template&id=28b6c2e0&scoped=true&lang=pug"
import script from "./reportBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./reportBreadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./reportBreadcrumbs.vue?vue&type=style&index=0&id=28b6c2e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b6c2e0",
  null
  
)

export default component.exports